export default __webpack_public_path__ + "static/media/6_2.1101b18f.jpg";